const SALE_DATE_MASK_MAX_DIGITS = 8;
const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const SALE_DATE_MASK_PLACEHOLDER = 'дд/мм/гггг';
export const SALE_DATE_MASK_MAX_LENGTH = 10;
export const SALE_DATE_MASK_PATTERN = /^\d{2}\/\d{2}\/\d{2}(\d{2})?$/;

export const formatSaleDateMask = (rawValue: string): string => {
  const digits = rawValue.replace(/\D/g, '').slice(0, SALE_DATE_MASK_MAX_DIGITS);

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

const resolveTwoDigitYear = (twoDigitYear: number): number => {
  const currentYear = new Date().getFullYear();
  const currentCentury = Math.floor(currentYear / 100) * 100;
  const candidateYear = currentCentury + twoDigitYear;

  // Dates more than 1 year in the future belong to the previous century
  if (candidateYear > currentYear + 1) {
    return candidateYear - 100;
  }

  return candidateYear;
};

/** Converts UI mask `dd/mm/yy` or `dd/mm/yyyy` to API format `YYYY-MM-DD` */
export const convertSaleDateMaskToIso = (maskedDate: string): string => {
  const match = maskedDate.match(/^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/);

  if (!match) {
    return maskedDate;
  }

  const day = match[1];
  const month = match[2];
  const yearPart = match[3];
  const year = yearPart.length === 4 ? Number(yearPart) : resolveTwoDigitYear(Number(yearPart));

  return `${String(year).padStart(4, '0')}-${month}-${day}`;
};

/** Converts API format `YYYY-MM-DD` to UI mask `dd/mm/yyyy` */
export const convertIsoDateToSaleDateMask = (isoDate: string): string => {
  if (!ISO_DATE_PATTERN.test(isoDate)) {
    return isoDate;
  }

  const [year, month, day] = isoDate.split('-');

  return formatSaleDateMask(`${day}${month}${year}`);
};
